__webpack_require__.p = "/dev/597-synchro-afficher-les-raccourcis-claviers-s-i-d-sur-les-bout/";